import React from 'react';
import * as Styled from './StyledFormInput';

export const FormInputEmpty = props => (
    <Styled.FormInput name="empty">{props.children}</Styled.FormInput>
);
export const empty = FormInputEmpty;
export default FormInputEmpty;
